import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/logo.png'
import _imports_1 from '../assets/logo-ksg.png'


const _hoisted_1 = { class: "krakenlogo-container" }
const _hoisted_2 = { class: "version ddl" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "search-container" }
const _hoisted_5 = { class: "search-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_games = _resolveComponent("games")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("img", {
        class: "krakenlogo",
        alt: "Kraken Logo",
        src: _imports_0
      }, null, -1)),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.appVersion), 1)
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", null, [
      _createElementVNode("img", {
        class: "logo",
        alt: "KSG Logo",
        src: _imports_1
      })
    ], -1)),
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.parameters.environment) = $event)),
      class: "server ddl",
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onEnvironmentChange && _ctx.onEnvironmentChange(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.environments, (environment) => {
        return (_openBlock(), _createElementBlock("option", {
          key: environment.id,
          value: environment
        }, _toDisplayString(environment.name), 9, _hoisted_3))
      }), 128))
    ], 544), [
      [_vModelSelect, _ctx.parameters.environment]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.gameFilter) = $event)),
          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterGames && _ctx.filterGames(...args))),
          placeholder: "Search games...",
          class: "search-input",
          type: "text"
        }, null, 544), [
          [_vModelText, _ctx.gameFilter]
        ]),
        (_ctx.gameFilter)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearFilter && _ctx.clearFilter(...args))),
              class: "clear-button",
              type: "button"
            }, " × "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_games, { "display-games": _ctx.filteredKsgGames }, null, 8, ["display-games"])
  ]))
}